import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/playground')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/playground' })
  },
})
